<!--<app-product-breadcrumb [title]="'menu.visite'" [breadcrumb]="'menu.visite'"></app-product-breadcrumb>-->

<section class="p-0">
    <app-slider-visit [sliders]="sliders" [textClass]="'text-center'" [buttonText]="'visite.btn-reserve' | translate">
    </app-slider-visit>
</section>

<section>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2 class="gold-title text-center">{{'visite.info1.titolo' | translate}}</h2>
            </div>
            <div class="col-md-8">
                <div>
                    <p class="text" [innerHTML]="'visite.info1.paragrafo1'  | translate"> </p>
                    <p class="text" [innerHTML]="'visite.info1.paragrafo2'  | translate"> </p>
                </div>
            </div>
            <div class="col-md-4 m-0">
                <div class="float-right">
                    <img src="assets/soragna/caseificio_foto00.jpeg" style="width: 100%;" alt="Caseificio Soragna">
                </div>
            </div>
            <div class="col-md-12 mt-3" *ngIf="caseificiAperti">
                <div style="border: #B8AB69 solid 2px;">
                    <p class="text m-4" [innerHTML]="'visite.info1.paragrafo3'  | translate"> </p>
                </div>
            </div>
            <div class="col-md-12 mt-3 text-center">
                <a routerLink="/visits" fragment="book">
                    <button class="btn btn-solid" type="submit">{{'visite.btn-reserve' | translate}}</button>
                </a>
            </div>
            <div class="col-md-12 mt-3">
                <div class="ornament"></div>
            </div>
            <!--<div class="col-md-12 mt-3">
                <app-services></app-services>
            </div>-->
            <div class="col-md-12 pt-4">
                <div>
                    <p class="text" [innerHTML]="'visite.info2'  | translate">
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="ornament"></div>

<section class="contact-page section-b-space" id="book">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <form (ngSubmit)="reserveNow()" [formGroup]="visitForm" class="visit-ticket-layout" #ticketLayout>
                    <div class="visit-form-panel">
                        <div class="visit-field-group">
                            <div class="visit-group-head">
                                <h3>{{ 'Lingua e data' | translate }}</h3>
                            </div>

                            <div class="visit-lang-toggle" role="group">
                                <button type="button" [class.active]="form.Language.value === 'italiano'"
                                    (click)="setLanguage('italiano')">Italiano</button>
                                <button type="button" [class.active]="form.Language.value === 'english'"
                                    (click)="setLanguage('english')">English</button>
                            </div>

                            <div class="visit-gift-row">
                                <div>
                                    <span class="visit-field-label">{{ 'È un regalo?' | translate }}</span>
                                    <p>
 {{ "Spunta qui per rendere data e orario facoltativi. Il destinatario potrà scegliere la data della visita tramite l'email che riceverà dopo il tuo acquisto." | translate }}</p>
                                </div>
                                <label class="visit-switch">
                                    <input type="checkbox" formControlName="Regalo" (change)="setAsRegalo($event)" />
                                    <span class="track"></span>
                                    <span class="thumb"></span>
                                </label>
                            </div>
                            <div class="visit-gift-reveal" *ngIf="visitForm.get('Regalo')?.value == true">
                                <label class="visit-field">
                                    <span class="visit-field-label">{{'Email destinatario del regalo'| translate
                                        }}*</span>
                                    <input type="text" formControlName="EmailDestinatarioRegalo"
                                        #emailDestinatarioRegaloInput
                                        placeholder="{{'Email destinatario del regalo' | translate }}"
                                        [ngClass]="{'is-invalid': submitted && form.EmailDestinatarioRegalo.errors}" />
                                    <div *ngIf="submitted && form.EmailDestinatarioRegalo.errors"
                                        class="invalid-feedback d-block">
                                        <span *ngIf="form.EmailDestinatarioRegalo.errors.required">{{
                                            'visite.form.Obbligatorio' | translate }}</span>
                                    </div>
                                </label>
                            </div>

                            <div class="visit-row cols-2" *ngIf="visitForm.get('Regalo')?.value !== true">
                                <div class="visit-field visit-date-field">
                                    <span class="visit-field-label">{{ 'visite.form.Data' | translate }}*</span>
                                    <input type="text" class="visit-date-display" readonly
                                        placeholder="{{ 'visite.form.Data' | translate }}" [(ngModel)]="dateModel"
                                        [ngModelOptions]="{standalone: true}" ngbDatepicker
                                        #visitDatepicker="ngbDatepicker" [minDate]="minDate"
                                        [markDisabled]="isDateDisabled" (dateSelect)="onDateSelect($event)"
                                        (click)="visitDatepicker.toggle()"
                                        [ngClass]="{'is-invalid': submitted && form.VisitDate.errors}" />
                                    <span class="visit-chevron">▾</span>
                                    <div *ngIf="submitted && form.VisitDate.errors" class="invalid-feedback d-block">
                                        <span *ngIf="form.VisitDate.errors.required">{{
                                            'visite.form.Obbligatorio' |
                                            translate }}</span>
                                    </div>
                                </div>

                                <div class="visit-field">
                                    <span class="visit-field-label">{{ 'visite.form.Orario' | translate
                                        }}*</span>
                                    <div class="visit-time-pills">
                                        <button type="button" disabled *ngIf="!hasTimeOptions">{{
                                            timeOptions[0]?.ora
                                            | translate }}</button>
                                        <ng-container *ngFor="let item of timeOptions">
                                            <button type="button" *ngIf="item.id !== ''"
                                                [class.active]="form.VisitTime.value === item.id"
                                                (click)="selectVisitTime(item.id)">{{ item.ora }}</button>
                                        </ng-container>
                                    </div>
                                    <div *ngIf="submitted && (form.VisitTime.errors || (visitForm.get('VisitTime')?.value === '' && visitForm.get('Regalo')?.value !== true))"
                                        class="invalid-feedback d-block">
                                        <span>{{ 'visite.form.Obbligatorio' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="visit-field-group">
                            <div class="visit-group-head">
                                <h3>{{ 'Chi viene' | translate }}</h3>
                            </div>

                            <div class="visit-row cols-3">
                                <div class="visit-stepper-row">
                                    <span class="visit-stepper-label">{{ 'visite.form.Persone' | translate
                                        }}</span>
                                    <div class="visit-stepper">
                                        <button type="button" (click)="adjustGuests('Nperson', -1)">−</button>
                                        <output>{{ form.Nperson.value }}</output>
                                        <button type="button" (click)="adjustGuests('Nperson', 1)">+</button>
                                    </div>
                                </div>
                                <div class="visit-stepper-row">
                                    <span class="visit-stepper-label">{{ 'visite.form.Bambini' | translate
                                        }}</span>
                                    <div class="visit-stepper">
                                        <button type="button" (click)="adjustGuests('Nchild', -1)">−</button>
                                        <output>{{ form.Nchild.value || 0 }}</output>
                                        <button type="button" (click)="adjustGuests('Nchild', 1)">+</button>
                                    </div>
                                </div>
                                <div class="visit-stepper-row">
                                    <span class="visit-stepper-label">{{ 'Bambini sotto 6 anni' | translate
                                        }} <em>({{ 'Gratis' | translate }})</em></span>
                                    <div class="visit-stepper">
                                        <button type="button"
                                            (click)="adjustGuests('NchildUnder6', -1)">−</button>
                                        <output>{{ form.NchildUnder6.value || 0 }}</output>
                                        <button type="button" (click)="adjustGuests('NchildUnder6', 1)">+</button>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="submitted && (form.Nperson.errors || form.Nchild.errors || form.NchildUnder6.errors)"
                                class="invalid-feedback d-block">
                                <span>{{ 'visite.form.Obbligatorio' | translate }}</span>
                            </div>
                        </div>

                        <div class="visit-field-group">
                            <div class="visit-group-head">
                                <h3>{{ 'Degustazione' | translate }}</h3>
                            </div>
                            <div class="visit-formula-tiles">
                                <button type="button" class="visit-formula-tile"
                                    [class.active]="!form.Tasting.value && !form.Tasting2.value && !form.Tasting3.value"
                                    (click)="setFormula('solo')">
                                    <span class="ft-name">{{ 'solo visita guidata' | translate }}</span>
                                    <span class="ft-price" *ngIf="prezzi">
                                        <span class="ft-price-line">{{ 'Adulto' | translate }} €{{ prezzi.PrezzoAdulto }}</span>
                                        <span class="ft-price-line">{{ 'Bambino' | translate }} €{{ prezzi.PrezzoBambino }}</span>
                                    </span>
                                </button>
                                <button type="button" class="visit-formula-tile" [class.active]="form.Tasting.value"
                                    (click)="setFormula('degustazione')">
                                    <span class="ft-name">{{ 'visite.form.Degustazione' | translate }}</span>
                                    <span class="ft-price" *ngIf="prezzi">
                                        <span class="ft-price-line">{{ 'Adulto' | translate }} €{{ prezzi.PrezzoAdultoDeg }}</span>
                                        <span class="ft-price-line">{{ 'Bambino' | translate }} €{{ prezzi.PrezzoBambinoDeg }}</span>
                                    </span>
                                </button>
                                <button type="button" class="visit-formula-tile" *ngIf="isDegustazioneAnoliniAvailable"
                                    [class.active]="form.Tasting2.value" (click)="setFormula('anolini')">
                                    <span class="ft-name">{{ 'visite.form.DegustazioneAnolini' | translate
                                        }}</span>
                                    <span class="ft-price" *ngIf="prezzi">
                                        <span class="ft-price-line">{{ 'Adulto' | translate }} €{{ prezzi.PrezzoAdultoAnolini }}</span>
                                        <span class="ft-price-line">{{ 'Bambino' | translate }} €{{ prezzi.PrezzoBambinoAnolini }}</span>
                                    </span>
                                </button>
                                <button type="button" class="visit-formula-tile" *ngIf="isDegustazionePaninoAvailable"
                                    [class.active]="form.Tasting3.value" (click)="setFormula('panino')">
                                    <span class="ft-name">{{ 'visite.form.DegustazionePanino' | translate
                                        }}</span>
                                    <span class="ft-price" *ngIf="prezzi">
                                        <span class="ft-price-line">{{ 'Adulto' | translate }} €{{ prezzi.PrezzoAdultoPanino }}</span>
                                        <span class="ft-price-line">{{ 'Bambino' | translate }} €{{ prezzi.PrezzoBambinoPanino }}</span>
                                    </span>
                                </button>
                            </div>
                        </div>

                        <div class="visit-field-group">
                            <div class="visit-group-head">
                                <h3>{{ 'I tuoi dati' | translate }}</h3>
                            </div>

                            <div class="visit-row cols-2">
                                <label class="visit-field">
                                    <span class="visit-field-label">{{'visite.form.Nome' | translate}}</span>
                                    <input type="text" formControlName="FirstName"
                                        placeholder="{{'visite.form.Nome' | translate}}"
                                        [ngClass]="{'is-invalid': submitted && form.FirstName.errors}" />
                                    <div *ngIf="submitted && form.FirstName.errors" class="invalid-feedback d-block">
                                        <span *ngIf="form.FirstName.errors.required">{{
                                            'visite.form.Obbligatorio' |
                                            translate}}</span>
                                        <span *ngIf="form.FirstName.errors.maxlength">{{'visite.form.Max' |
                                            translate
                                            }} 50 {{'visite.form.Caratteri' | translate}}</span>
                                    </div>
                                </label>
                                <label class="visit-field">
                                    <span class="visit-field-label">{{'visite.form.Cognome' | translate}}</span>
                                    <input type="text" formControlName="LastName"
                                        placeholder="{{'visite.form.Cognome' | translate}}"
                                        [ngClass]="{'is-invalid': submitted && form.LastName.errors}" />
                                    <div *ngIf="submitted && form.LastName.errors" class="invalid-feedback d-block">
                                        <span *ngIf="form.LastName.errors.required">{{
                                            'visite.form.Obbligatorio' |
                                            translate }}</span>
                                        <span *ngIf="form.LastName.errors.maxlength">{{'visite.form.Max' |
                                            translate
                                            }} 50 {{'visite.form.Caratteri' | translate}}</span>
                                    </div>
                                </label>
                            </div>

                            <div class="visit-row cols-2">
                                <label class="visit-field">
                                    <span class="visit-field-label">{{'visite.form.Telefono' |
                                        translate}}</span>
                                    <input type="number" formControlName="Phone"
                                        placeholder="{{'visite.form.Telefono' | translate}}"
                                        [ngClass]="{'is-invalid': submitted && form.Phone.errors}" />
                                    <div *ngIf="submitted && form.Phone.errors" class="invalid-feedback d-block">
                                        <span *ngIf="form.Phone.errors.required">{{ 'visite.form.Obbligatorio' |
                                            translate }}</span>
                                        <span *ngIf="form.Phone.errors.maxlength">{{'visite.form.Max' |
                                            translate }}
                                            15 {{'visite.form.Caratteri' | translate}} </span>
                                        <span *ngIf="form.Phone.errors.pattern">{{ 'visite.form.Numeri' |
                                            translate
                                            }}</span>
                                    </div>
                                </label>
                                <label class="visit-field">
                                    <span class="visit-field-label">{{'visite.form.Email' | translate}}</span>
                                    <input type="text" formControlName="Email"
                                        placeholder="{{'visite.form.Email' | translate}}"
                                        [ngClass]="{'is-invalid': submitted && form.Email.errors}" />
                                    <div *ngIf="submitted && form.Email.errors" class="invalid-feedback d-block">
                                        <span *ngIf="form.Email.errors.required">{{ 'visite.form.Obbligatorio' |
                                            translate }}</span>
                                        <span *ngIf="form.Email.errors.email">{{ 'visite.form.EmailNonValida' |
                                            translate }}</span>
                                    </div>
                                </label>
                            </div>

                            <div style="display: none;">
                                <input type="text" formControlName="Paese" />
                            </div>
                        </div>

                         <div class="visit-field-group">
                             <div class="visit-group-info">
                                <p  [innerHTML]="'visite.info3' | translate"></p>
                            </div>
                         </div>

                        <div>
                            <label class="visit-privacy-line">
                                <input type="checkbox" formControlName="AcceptPrivacy" #privacyCheckbox
                                    [ngClass]="{'is-invalid': submitted && form.AcceptPrivacy.errors}" />
                                <span>
                                    <a class="accept-privacy" (click)="openNewTab()">{{ 'visite.form.AcceptPrivacy' |
                                        translate }}</a>
                                </span>
                            </label>
                            <div *ngIf="submitted && form.AcceptPrivacy.errors" class="invalid-feedback d-block">
                                <span *ngIf="form.AcceptPrivacy.errors.required">{{ 'visite.form.Obbligatorio' |
                                    translate }}</span>
                            </div>
                        </div>
                    </div>

                    <aside class="visit-ticket-stub" #ticketStub>
                        <span class="stub-eyebrow">{{ 'Il tuo biglietto' | translate }}</span>
                        <h3>{{ 'visite.btn-reserve' | translate }}</h3>
                        <dl class="stub-details">
                            <div>
                                <dt>{{ 'visite.form.Lingua' | translate }}</dt>
                                <dd>{{ form.Language.value === 'italiano' ? 'Italiano' : 'English' }}</dd>
                            </div>
                            <div *ngIf="visitForm.get('Regalo')?.value !== true">
                                <dt>{{ 'visite.form.Data' | translate }}</dt>
                                <dd>{{ formattedVisitDate || ('visite.form.Data' | translate) }}</dd>
                            </div>
                            <div *ngIf="visitForm.get('Regalo')?.value !== true">
                                <dt>{{ 'visite.form.Orario' | translate }}</dt>
                                <dd>{{ (formattedVisitTime | translate) || '—' }}</dd>
                            </div>
                            <div>
                                <dt>{{ 'Persone' | translate }}</dt>
                                <dd>{{ form.Nperson.value }} + {{ form.Nchild.value || 0 }} + {{
                                    form.NchildUnder6.value || 0 }}</dd>
                            </div>
                            <div>
                                <dt>{{ 'Formula' | translate }}</dt>
                                <dd>{{ formulaLabel | translate }}</dd>
                            </div>
                        </dl>
                        <div class="stub-perforation"></div>
                        <div class="stub-total">
                            <span>{{ 'Totale' | translate }}</span>
                            <strong>€{{ totaleVisita }}</strong>
                        </div>
                        <button class="btn btn-solid visit-cta" type="submit">{{ 'visite.form.Invia' | translate
                            }}</button>
                    </aside>
                </form>
            </div>
        </div>
    </div>
</section>

<div class="ornament"></div><br>

<app-email-confirm #emailSent></app-email-confirm>
<app-tap-to-top></app-tap-to-top>